module.exports = __webpack_public_path__ + "img/Origine_France.5a255c28.png";